<script setup lang="ts">
  defineOptions({
    name: 'CPPortalSidebarFooter',
  })

  import { ref } from 'vue'

  import ProfileCard from '@common/shared-ui-layer/components/ProfileCard.vue'

  import { useAuth } from '@common/auth-layer/composables/useAuth'

  defineProps({
    isCollapsed: {
      type: Boolean,
      required: true,
    },
  })

  const { store: authStore } = useAuth()

  const profileMenuOpen = ref(false)
</script>

<template>
  <div class="cp-portal-sidebar-footer-profile w-full min-w-0 overflow-visible pt-2">
    <ProfileCard
      v-if="authStore.isAuthenticated"
      :profile-card-is-open="profileMenuOpen"
      layout="sidebar"
      :is-collapsed="isCollapsed"
      @update:profileCardIsOpen="profileMenuOpen = $event"
    />
  </div>
</template>
